const Array = (path) => (rowData) =>
  rowData[path] ? rowData[path].join(', ') : ''

export default Array
